import Icon from './Icon';

const GoToArrow = (props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.125 6.27502L5.875 14.525"
        stroke="#3C4852"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33301 6.23334L14.1247 6.27417L14.1663 12.0667"
        stroke="#3C4852"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export default GoToArrow;
